/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { proposalsGetApiV3LatestProposalId } from "../../funcs/proposalsGetApiV3LatestProposalId.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$proposalsGetApiV3LatestProposalId: ToolDefinition = {
  name: "proposals-get-api-v3-latest-proposal-id",
  description: ``,
  tool: async (client, ctx) => {
    const [result, apiCall] = await proposalsGetApiV3LatestProposalId(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
